import gql from "graphql-tag";
import graphqlClient from "@/http/graphql/hr";

const CONTRACT_TYPES = `
    ContractTypes {
        id
        name
        code
    }`;

const ADD_CONTRACT = `
    create_labor_contract (
        code: $code
        start_date: $start_date,
        end_date: $end_date,
        signed_at: $signed_at,
        quit_at: $quit_at,
        quit_desc: $quit_desc,
        salary: $salary,
        description: $description,
        employee_id: $employee_id,
        contracttype_id: $contracttype_id,
        status: $status,
        department_id: $department_id,
        title_id: $title_id,
        transportation: $transportation
    ) {
		id
        start_date
        end_date
	}
`;

const UPDATE_CONTRACT = `
    update_labor_contract(
        id: $id,
        code: $code
        start_date: $start_date,
        end_date: $end_date,
        signed_at: $signed_at,
        quit_at: $quit_at,
        quit_desc: $quit_desc,
        salary: $salary,
        description: $description,
        employee_id: $employee_id,
        contracttype_id: $contracttype_id,
        status: $status,
        department_id: $department_id,
        title_id: $title_id,
        transportation: $transportation
    ) {
        id
        start_date
        end_date
	}
`;

const CONTRACT_BY_EMPLOYEE = `
    LaborContractByEmployee(employee_id: $employee_id) {
        id
        start_date
        end_date
		salary
		code
        contracttype_id
        department_id
        status
        title_id
		transportation
		signed_at
		description
        employee {
            id
            name
		}
		title {
			id name
		  }
		department {
			id name
		}
		contracttype {
			id name
		}
    }`;

const ECONOMIC_CONTRACTS = `
	EconomicContracts(limit: $limit, page: $page, search: $search) {
		data {
		  id
		  name
		  code
		  start_date
		  end_date
		  description
		  files {
			id
			file_name
			file_size
			path
			extension
		  }
		  info_a
		  info_b
		}
		total
	}`;

const CREATE_ECONOMIC_CONTRACT = `
	create_economic_contract(
		name: $name,
		code: $code,
		start_date: $start_date,
		end_date: $end_date,
		description: $description,
		info_a: $info_a,
		info_b: $info_b,
		files: $files
	) {
		id
		name
		code
		start_date
		end_date
		info_a
		info_b
		description
		files {
			id
			file_name
			file_size
			path
			extension
		}
	}`;
const UPDATE_ECONOMIC_CONTRACT = `
	update_economic_contract(
		id: $id,
		name: $name,
		code: $code,
		start_date: $start_date,
		end_date: $end_date,
		description: $description,
		info_a: $info_a,
		info_b: $info_b,
		files: $files
	) {
		id
		name
		code
		start_date
		end_date
		info_a
		info_b
		description
		files {
			id
			file_name
			file_size
			path
			extension
		}
	}`;
const DELETE_ECONOMIC_CONTRACT = `
	delete_economic_contract(
		id: $id
	)`;
export default {
	addContract(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ContractsManagementAdd (
					$code: String!,
                    $start_date: DateTime!,
                    $end_date: DateTime,
                    $signed_at: DateTime,
                    $quit_at: DateTime,
                    $quit_desc: String,
                    $salary: Int,
                    $description: String,
                    $employee_id: Int,
                    $contracttype_id: Int,
                    $status: Int!,
                    $department_id: Int,
                    $title_id: Int,
                    $transportation: String
					) {
						${ADD_CONTRACT}
					}
				`,
				variables: {
					code: payload.code ? payload.code : "",
					start_date: payload.start_date ? payload.start_date : "",
					end_date: payload.end_date ? payload.end_date : "",
					signed_at: payload.signed_at ? payload.signed_at : "",
					quit_at: payload.quit_at ? payload.quit_at : "",
					quit_desc: payload.quit_desc ? payload.quit_desc : "",
					salary: payload.salary ? payload.salary : 0,
					description: payload.description ? payload.description : "",
					employee_id: payload.employee_id ? payload.employee_id : null,
					contracttype_id: payload.contracttype_id ? payload.contracttype_id : null,
					status: payload.status ? payload.status : 0,
					department_id: payload.department_id ? payload.department_id : null,
					title_id: payload.title_id ? payload.title_id : null,
					transportation: payload.transportation ? payload.transportation : ""
				}
			})
			.then(response => {
				return { contract: response.data.create_labor_contract };
			});
	},
	updateContract(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ContractsManagementUpdate (
					$id: Int!,
                    $code: String!,
                    $start_date: DateTime!,
                    $end_date: DateTime,
                    $signed_at: DateTime,
                    $quit_at: DateTime,
                    $quit_desc: String,
                    $salary: Int,
                    $description: String,
                    $employee_id: Int,
                    $contracttype_id: Int,
                    $status: Int!,
                    $department_id: Int,
                    $title_id: Int,
                    $transportation: String
					) {
						${UPDATE_CONTRACT}
					}
				`,
				variables: {
					id: payload.id,
					code: payload.code ? payload.code : "",
					start_date: payload.start_date ? payload.start_date : "",
					end_date: payload.end_date ? payload.end_date : "",
					signed_at: payload.signed_at ? payload.signed_at : "",
					quit_at: payload.quit_at ? payload.quit_at : "",
					quit_desc: payload.quit_desc ? payload.quit_desc : "",
					salary: payload.salary ? payload.salary : 0,
					description: payload.description ? payload.description : "",
					employee_id: payload.employee_id ? payload.employee_id : null,
					contracttype_id: payload.contracttype_id ? payload.contracttype_id : null,
					status: payload.status ? payload.status : 0,
					department_id: payload.department_id ? payload.department_id : null,
					title_id: payload.title_id ? payload.title_id : null,
					transportation: payload.transportation ? payload.transportation : ""
				}
			})
			.then(response => {
				return { contract: response.data.update_labor_contract };
			});
	},

	laborContractByEmployee(payload) {
		const queryOptions = {
			query: gql`query LaborContractByEmployee ($employee_id: Int!) {
				${CONTRACT_BY_EMPLOYEE}
			}
			`,
			variables: {
				employee_id: payload.employee_id
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				contracts: response.data.LaborContractByEmployee
			};
		});
	},
	contractTypes() {
		const queryOptions = {
			query: gql`query ContractTypes {
				${CONTRACT_TYPES}
			}
			`
		};

		return graphqlClient.query(queryOptions).then(response => {
			return {
				contractTypes: response.data.ContractTypes
			};
		});
	},
	// EconomicContracts
	getEconomicContracts(payload) {
		const queryOptions = {
			query: gql`query GetEconomicContracts($page: Int!, $limit: Int!, $search: String) {
				${ECONOMIC_CONTRACTS}
			}
			`,
			variables: {
				page: payload.page,
				limit: payload.limit,
				search: payload.search
			}
		};

		return graphqlClient.query(queryOptions).then(response => {
			return {
				economicContracts: response.data.EconomicContracts.data,
				total: response.data.EconomicContracts.total
			};
		});
	},
	addEconomicContract(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation EconomicContractAdd (
					$name: String!,
					$code: String!,
					$start_date: DateTime!,
					$end_date: DateTime,
					$description: String,
					$info_a: String,
					$info_b: String,
					$files: [Int]
					) {
						${CREATE_ECONOMIC_CONTRACT}
					}
				`,
				variables: {
					name: payload.name ? payload.name : "",
					code: payload.code ? payload.code : "",
					start_date: payload.start_date ? payload.start_date : "",
					end_date: payload.end_date ? payload.end_date : "",
					info_a: payload.info_a ? payload.info_a : "",
					info_b: payload.info_b ? payload.info_b : "",
					description: payload.description ? payload.description : "",
					files: payload.files ? payload.files : []
				}
			})
			.then(response => {
				return response.data.create_economic_contract;
			});
	},
	updateEconomicContract(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation EconomicContractUpdate (
					$id: Int!,
                    $name: String!,
					$code: String!,
					$start_date: DateTime!,
					$end_date: DateTime,
					$description: String,
					$info_a: String,
					$info_b: String,
					$files: [Int]
					) {
						${UPDATE_ECONOMIC_CONTRACT}
					}
				`,
				variables: {
					id: payload.id,
					name: payload.name ? payload.name : "",
					code: payload.code ? payload.code : "",
					start_date: payload.start_date ? payload.start_date : "",
					end_date: payload.end_date ? payload.end_date : "",
					info_a: payload.info_a ? payload.info_a : "",
					info_b: payload.info_b ? payload.info_b : "",
					description: payload.description ? payload.description : "",
					files: payload.files ? payload.files : []
				}
			})
			.then(response => {
				return response.data.update_economic_contract;
			});
	},
	deleteEconomicContract(id) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation EconomicContractDelete ($id: Int!) {
					${DELETE_ECONOMIC_CONTRACT}
				}
			`,
				variables: {
					id: id
				}
			})
			.then(response => response.delete_economic_contract);
	}
};
